module.exports = __webpack_public_path__ + "static/img/eml1.fc843688.png";